/** =========================================================
 * Module: items-append.directive.js
 * Data items append
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.components')
    .directive('itemsAppend', itemsAppend);

  itemsAppend.$inject = ['$rootScope'];

  function itemsAppend($rootScope) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/views/components/items-append.html',
      link: link,
      scope: {
        config: '='
      }
    };

    return directive;

    function link($scope) {
      $scope.loading = false;
      $scope.config.appendData = function () {
        return $rootScope.helpers.defaultAppendData($scope.config);
      };

      if ($scope.config.items) {
        activate();
      } else {
        var data = $scope.$watch('config', function (config) {
          if (config && config.items && config.model && config.getData && config.getDataParams) {
            activate();
            data();
          }
        }, true);
      }

      function activate() {
        $scope.paginationLimit = parseInt($scope.config.getDataParams.pagination_limit ? $scope.config.getDataParams.pagination_limit : $rootScope.appConfig.paginationLimit, 10);

        $scope.append = function () {
          try {
            if ($scope.loading || $scope.config.pages === 1 || $scope.config.getDataParams.page >= $scope.config.pages) {
              return;
            }

            $scope.config.getDataParams.page ? $scope.config.getDataParams.page++ : $scope.config.getDataParams.page = 2;
            $scope.loading = true;

            $scope.config.appendData().then(function () {
              $scope.$applyAsync(function () {
                $scope.loading = false;
              });
            });
          } catch (error) {
            Raven.captureException(error);
          }
        };
      }
    }
  }
})();
